module.exports = __webpack_public_path__ + "media/images/front/advisory-lp/img_doctor01-96d0e0f866aa0a0e7807be45a66ca251.jpg";